import Axios from "axios";
import PtsAlert from "../component/ptsAlert/PtsAlert";

// Helper to normalize Axios errors
const parseAxiosError = (error) => {
  const status = error && error.response && error.response.status;
  const message =
    (error && error.response && error.response.data && error.response.data.message) ||
    (error && error.message) ||
    null;
  const isTimeout = error && (error.code === "ECONNABORTED" || error.name === "TimeoutError");
  return { status, message, isTimeout };
};

export const serverUrl = "/assetTrackApi";

export const callPostServiceForPDFData = (url, data) => {
  return new Promise(function (accept, reject) {
    Axios.post(url, data)
      .then((response) => {
        const responseData = response.data;
        if (undefined !== responseData && responseData.length > 0) {
          accept(responseData);
        } else {
          let errorMessage = "No Data From Server";
          PtsAlert.error("No Data Received from Server");
          reject(errorMessage);
        }
      })
      .catch((error) => {
        const { message, isTimeout } = parseAxiosError(error);
        if (isTimeout) {
          PtsAlert.error("Can't reach to server, please try again later.");
          reject("Can't reach to server, please try again later.");
        } else {
          const errMsg = message || "Unknown Error occurred";
          PtsAlert.error(errMsg);
          reject(errMsg);
        }
      });
  });
};

const showLoader = () =>
  document.getElementById("iAmUniqueModalAT")
    ? (document.getElementById("iAmUniqueModalAT").style.display = "block")
    : "";
const hideLoader = () =>
  document.getElementById("iAmUniqueModalAT")
    ? (document.getElementById("iAmUniqueModalAT").style.display = "none")
    : "";

const buildServerUrl = (prefix, url) => {
  let full = (prefix || "") + (url || "");
  full = full.replace(/\/\//g, "/");
  full = full.replace(/\/\+/g, "/");
  return full;
};

export const callPostFileDownload = (url, data) => {
  url = buildServerUrl(serverUrl, url);
  return new Promise(function (accept, reject) {
    Axios.post(url, data)
      .then((response) => accept(response))
      .catch((error) => {
        const { status, message, isTimeout } = parseAxiosError(error);
        if (isTimeout) {
          reject("Can't reach to server, please try again later.");
        } else if (status) {
          let errorMessage = message || "Unknown Error occurred";
          switch (status) {
            case 401:
              errorMessage = "You are not authenticated to call this service";
              break;
            case 403:
              errorMessage =
                "You are not authorized to perform this operation or the resource is unavailable for some reason";
              break;
            case 500:
            case 408:
            case 504:
              errorMessage = "Internal Server Error occurred, please try again later";
              break;
            case 599:
              errorMessage = "Can't reach to server, please try again later.";
              break;
            case 503:
              errorMessage = "Service you are trying is currently unavailable, please try again later.";
              break;
            default:
              errorMessage = "You are not authenticated to call this service";
              break;
          }
          reject(errorMessage);
        } else {
          reject(error);
        }
      });
  });
};

export const callPostFileUpload = (url, data) => {
  url = buildServerUrl(serverUrl, url);
  return new Promise(function (accept, reject) {
    Axios.post(url, data)
      .then((response) => {
        const responseData = response.data;
        if (responseData.status === "SUCCESS") {
          accept(responseData);
        } else {
          let errCode = responseData.errorCode;
          responseData.message = responseData.message === null ? "Null Response" : responseData.message;
          PtsAlert.error(responseData.message);
          if (errCode === "SEP_101") {
            try {
              localStorage.clear();
            } catch (err) {}
            window.location = "/#/signinEmail";
            reject("");
          } else {
            accept(responseData);
          }
        }
      })
      .catch((error) => {
        const { status, message, isTimeout } = parseAxiosError(error);
        if (isTimeout) {
          reject("Can't reach to server, please try again later.");
        } else if (status) {
          let errorMessage = message || "Unknown Error occurred";
          switch (status) {
            case 401:
              errorMessage = "You are not authenticated to call this service";
              break;
            case 403:
              errorMessage =
                "You are not authorized to perform this operation or the resource is unavailable for some reason";
              break;
            case 500:
            case 408:
            case 504:
              errorMessage = "Internal Server Error occurred, please try again later";
              break;
            case 599:
              errorMessage = "Can't reach to server, please try again later.";
              break;
            case 503:
              errorMessage = "Service you are trying is currently unavailable, please try again later.";
              break;
            default:
              errorMessage = "You are not authenticated to call this service";
              break;
          }
          reject(errorMessage);
        } else {
          reject(error);
        }
      });
  });
};

export const callPostService = (url, data) => {
  url = buildServerUrl(serverUrl, url);
  hideLoader();
  showLoader();
  return new Promise(function (accept, reject) {
    Axios.post(url, data)
      .then((response) => {
        hideLoader();
        const responseData = response.data;
        if (responseData.status === "SUCCESS") {
          accept(responseData);
        } else {
          responseData.message = responseData.message === null ? "Null Response" : responseData.message;
          PtsAlert.error(responseData.message);
          let errCode = responseData.errorCode;
          if (errCode === "SEP_101") {
            try {
              localStorage.clear();
            } catch (err) {}
            window.location = "/#/signinEmail";
          } else {
            accept(responseData);
          }
        }
      })
      .catch((error) => {
        hideLoader();
        const { status, message, isTimeout } = parseAxiosError(error);
        if (isTimeout) {
          PtsAlert.error("Can't reach to server, please try again later.");
          reject("Can't reach to server, please try again later.");
        } else if (status) {
          let errorMessage = message || "Unknown Error occurred";
          switch (status) {
            case 401:
              errorMessage = "You are not authenticated to call this service";
              break;
            case 403:
              errorMessage =
                "You are not authorized to perform this operation or the resource is unavailable for some reason";
              break;
            case 500:
            case 408:
            case 504:
              errorMessage = "Internal Server Error occurred, please try again later";
              break;
            case 599:
              errorMessage = "Can't reach to server, please try again later.";
              break;
            case 503:
              errorMessage = "Service you are trying is currently unavailable, please try again later.";
              break;
            default:
              errorMessage = "You are not authenticated to call this service";
              break;
          }
          PtsAlert.error(errorMessage);
          reject(errorMessage);
        } else {
          const errMsg = message || "Unknown Error occurred";
          PtsAlert.error(errMsg);
          reject(error);
        }
      });
  });
};

export const callPostPtsTracking = (url, data) => {
  url = buildServerUrl("/ptsTracking", url);
  hideLoader();
  showLoader();
  return new Promise(function (accept, reject) {
    Axios.post(url, data)
      .then((response) => {
        hideLoader();
        const responseData = response.data;
        if (responseData.status === "SUCCESS") {
          accept(responseData);
        } else {
          let errCode = responseData.errorCode;
          responseData.message = responseData.message === null ? "Null Response" : responseData.message;
          PtsAlert.error(responseData.message);
          if (errCode === "SEP_101") {
            try {
              localStorage.clear();
            } catch (err) {}
            window.location = "/#/signinEmail";
          } else {
            accept(responseData);
          }
        }
      })
      .catch((error) => {
        hideLoader();
        const { status, message, isTimeout } = parseAxiosError(error);
        if (isTimeout) {
          PtsAlert.error("Can't reach to server, please try again later.");
          reject("Can't reach to server, please try again later.");
        } else if (status) {
          let errorMessage = message || "Unknown Error occurred";
          switch (status) {
            case 401:
              errorMessage = "You are not authenticated to call this service";
              break;
            case 403:
              errorMessage =
                "You are not authorized to perform this operation or the resource is unavailable for some reason";
              break;
            case 500:
            case 408:
            case 504:
              errorMessage = "Internal Server Error occurred, please try again later";
              break;
            case 599:
              errorMessage = "Can't reach to server, please try again later.";
              break;
            case 503:
              errorMessage = "Service you are trying is currently unavailable, please try again later.";
              break;
            default:
              errorMessage = "You are not authenticated to call this service";
              break;
          }
          PtsAlert.error(errorMessage);
          reject(errorMessage);
        } else {
          const errMsg = message || "Unknown Error occurred";
          PtsAlert.error(errMsg);
          reject(error);
        }
      });
  });
};

export const callPostServiceWithoutHeader = (url, data) => {
  url = buildServerUrl(serverUrl, url);
  hideLoader();
  showLoader();
  return new Promise(function (accept, reject) {
    Axios.post(url, data)
      .then((response) => {
        hideLoader();
        const responseData = response.data;
        if (responseData.status === "SUCCESS") {
          accept(responseData);
        } else {
          let errCode = responseData.errorCode;
          responseData.message = responseData.message === null ? "Null Response" : responseData.message;
          PtsAlert.error(responseData.message);
          if (errCode === "SEP_101") {
            try {
              localStorage.clear();
            } catch (err) {}
            window.location = "/#/signinEmail";
            reject("");
          } else {
            accept(responseData);
          }
        }
      })
      .catch((error) => {
        hideLoader();
        const { status, message, isTimeout } = parseAxiosError(error);
        if (isTimeout) {
          reject("Can't reach to server, please try again later.");
        } else if (status) {
          let errorMessage = message || "Unknown Error occurred";
          switch (status) {
            case 401:
              errorMessage = "You are not authenticated to call this service";
              break;
            case 403:
              errorMessage =
                "You are not authorized to perform this operation or the resource is unavailable for some reason";
              break;
            case 500:
            case 408:
            case 504:
              errorMessage = "Internal Server Error occurred, please try again later";
              break;
            case 599:
              errorMessage = "Can't reach to server, please try again later.";
              break;
            case 503:
              errorMessage = "Service you are trying is currently unavailable, please try again later.";
              break;
            default:
              errorMessage = "You are not authenticated to call this service";
              break;
          }
          reject(errorMessage);
        } else {
          reject(error);
        }
      });
  });
};

export const callGetService = (url, data) => {
  hideLoader();
  showLoader();
  return new Promise(function (accept, reject) {
    Axios.get(url, data)
      .then((response) => {
        hideLoader();
        const responseData = response.data;
        if (responseData.status === "SUCCESS") {
          accept(responseData);
        } else {
          let errCode = responseData.errorCode;
          responseData.message = responseData.message === null ? "Null Response" : responseData.message;
          PtsAlert.error(responseData.message);
          if (errCode === "SEP_101") {
            try {
              localStorage.clear();
            } catch (err) {}
            window.location = "/signInEmail";
            reject("");
          } else {
            accept(responseData);
          }
        }
      })
      .catch((error) => {
        hideLoader();
        const { status, message, isTimeout } = parseAxiosError(error);
        if (isTimeout) {
          PtsAlert.error("Can't reach to server, please try again later.");
          reject("Can't reach to server, please try again later.");
        } else if (status) {
          let errorMessage = message || "Unknown Error occurred";
          switch (status) {
            case 401:
              errorMessage = "You are not authenticated to call this service";
              break;
            case 403:
              errorMessage =
                "You are not authorized to perform this operation or the resource is unavailable for some reason";
              break;
            case 500:
            case 408:
            case 504:
              errorMessage = "Internal Server Error occurred, please try again later";
              break;
            case 599:
              errorMessage = "Can't reach to server, please try again later.";
              break;
            case 503:
              errorMessage = "Service you are trying is currently unavailable, please try again later.";
              break;
            default:
              errorMessage = "You are not authenticated to call this service";
              break;
          }
          PtsAlert.error(errorMessage);
          reject(errorMessage);
        } else {
          const errMsg = message || "Unknown Error occurred";
          PtsAlert.error(errMsg);
          reject(error);
        }
      });
  });
};

const fetchServerDataObject = {
  callPostFileDownload,
  callPostFileUpload,
  callPostService,
  callPostPtsTracking,
  callPostServiceForPDFData,
  callPostServiceWithoutHeader,
  hideLoader,
  callGetService,
};

export default fetchServerDataObject;
